import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import NowAiring from "@/pages/home/components/NowAiring";
import LatestUpdates from "@/pages/home/components/LatestUpdates";
import TopRated from "@/pages/home/components/TopRated";
import Exclusive from "@/pages/home/components/Exclusive";
import Library from "@/pages/home/components/Library";
import Ranking from "@/pages/home/components/Ranking";
import Guides from "@/pages/home/components/Guides";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <Navbar />
      <main className="w-full flex-1">
        <Hero />
        <NowAiring />
        <LatestUpdates />
        <TopRated />
        <Exclusive />
        <Library />
        <Ranking />
        <Guides />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}